function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4ccbb816\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"D:\\\\BuildAgent2\\\\work\\\\190b1d2d9f9a26c6\\\\Commerce\\\\Commerce.Web\\\\node_modules\\\\bootstrap-sass\\\\assets\\\\stylesheets\\\\bootstrap\\\\_variables.scss\",\"D:\\\\BuildAgent2\\\\work\\\\190b1d2d9f9a26c6\\\\Commerce\\\\Commerce.Web\\\\WebResources\\\\scss\\\\shared\\\\_global-variables.scss\",\"D:\\\\BuildAgent2\\\\work\\\\190b1d2d9f9a26c6\\\\Commerce\\\\Commerce.Web\\\\WebResources\\\\scss\\\\shared\\\\environment-variables\\\\production.scss\"]}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BouncePreventor.vue")
}
var normalizeComponent = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BouncePreventor.vue"
import __vue_script__ from "!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BouncePreventor.vue"
/* template */
import __vue_template__ from "!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4ccbb816\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BouncePreventor.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ccbb816"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/shared/components/BouncePreventor/BouncePreventor.vue
// module id = 276
// module chunks = 1 2 6 7 8 9